import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const ws = localStorage.getItem("wk_workspace");
  if (ws === "practica" && !config.headers["X-Workspace"]) config.headers["X-Workspace"] = "practica";
  return config;
});

export const fmtMXN = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(n || 0));

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("es-MX") : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("es-MX") : "—");

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Error inesperado";
}

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export default api;
